export enum HttpMethod {
    Get = 1,
    Post = 2,
    Delete = 3,
}

